// extracted by mini-css-extract-plugin
export default {"Markdown":"Markdown_iN6gn_v17-8-1","Lowlight":"Lowlight_GNEjX_v17-8-1"};